import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoginView from "../../components/Login/LoginView";
import MainWrapper from "../../Wrapper/MainWrapper";
import { getCookie } from "../../utils/helper";
import { IsNullUndefine } from "../../utils/helper";
export default function Login() {
  const navigate = useNavigate();
  useEffect(() => {
    // if (localStorage.getItem("yop-token")) {

    if (!IsNullUndefine(getCookie("yop-token"))) {
      navigate("/");
    }
  }, [navigate]);
  return (
    <>
      <MainWrapper>
        <LoginView />
      </MainWrapper>
    </>
  );
}
